import { Component, Input, OnInit, Output, ViewChild, EventEmitter, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { MsgConfig } from 'src/app/app.messages';
import { CommonService, RphVerificationService } from 'src/app/services';
import { AuditLogUtils, CommonUtil, NRxUtils } from 'src/app/utils';

@Component({
  selector: 'app-verification-checks',
  templateUrl: './verification-checks.component.html',
  styleUrls: ['./verification-checks.component.scss']
})
export class VerificationChecksComponent implements OnInit {
  verfData: any;
  verfMsg: any;
  verifiedArray:any=[];
  @ViewChild("VERFCONFIRMATION", { static: true })
  VERFCONFIRMATION: any;
  @Input() rxFG: any;
  @Input() flow: any;
  @Input() selectedRxList:any;
  @Input() frmScreen: any;
  @Input() frmResetDrug: any
  @Output()IsPopUpClosed = new EventEmitter();
  @Output() SelectedYesOrNo = new EventEmitter<boolean>();
  private _cmnUtils = inject(CommonUtil)
  allthreeVerifications: boolean;
  confirmMessage: any;
  removeEyeconImages = true;
  eyconDPVDocsExist: boolean;
  showCopayMessage: boolean;
  msgConfig = MsgConfig;
  rphVerified: boolean;

  constructor(private _modalService: NgbModal,  private _nrxUtils: NRxUtils, private _auditUtils: AuditLogUtils,private _rphServ: RphVerificationService,private _commonServ: CommonService) { }


  ngOnInit() {
    this.checkVerifications();
    this.eyconDPVDocsExist = this.rxFG?.value?.IsPillCounterDocumentsExists;
    this.showCopayMessage = this.rxFG?.value?.PrescReFill?.IsCopayPaid ? true : false;
  }

  checkVerifications () {
    this.verfData = "";
    this.verfMsg = "";
    const reqRxVerfStng = parseInt(this._commonServ.getSetttingValue("WorkFlowSettings", "Require_Rx_Verification"), 0);
    const origRxOrNt = (this.rxFG?.value && this.rxFG?.value["PrescReFill"] && (this.rxFG?.value["PrescReFill"]["ReFillNum"] === 0 && this.rxFG?.value["PrescReFill"]["PartialFillNo"] === 1));
    if (!this.selectedRxList && !this.frmScreen && this.rxFG?.value["rph1VerificationStatus"] && (this.rxFG?.value["rph1VerificationStatus"]).trim().toLowerCase() === "r" && (!this.frmResetDrug || (this.frmResetDrug && origRxOrNt && reqRxVerfStng && this._commonServ.getSetttingValue("WorkFlowSettings", "REQ_RX_VERF_ON_RX_CHG_FOR_ORG_FILL") === "1"))) {
      this.verfData = this.verfData + "X";
      this.verfMsg = this.verfMsg + "Rx ";
      // (this.verfMsg && this.verfMsg.length > 0 ?
      //   "and Rx Verification" : "Rx Verification " );
    }
    if(this.flow !== "ExcludeDPVANDRPH" && !this.selectedRxList) {
      if (this._cmnUtils.verifyIsDPVVerified(this.rxFG?.value) && (this.rxFG?.value["drugPickVerificationStatus"] && (this.rxFG?.value["drugPickVerificationStatus"]).toLowerCase() === "p")) {
        this.verfData = this.verfData + "D";
        this.verfMsg = this.verfMsg + (this.verfMsg && this.verfMsg.length > 0 ?
          "and Drug Pick " : "Drug Pick " );
      }
      if (!this.selectedRxList && this.rxFG?.value["rph2VerificationStatus"] && (this.rxFG?.value["rph2VerificationStatus"]).trim().toLowerCase() === "v") {
        this.verfData = this.verfData + "R";
        this.verfMsg =  this.verfMsg.includes("and") ? this.verfMsg.replace(" and", ",") : this.verfMsg;
        this.verfMsg = this.verfMsg + (this.verfMsg && this.verfMsg.length > 0 ?
          "and Pharmacist" : "Pharmacist" );
        this.rphVerified = true;
      }
      if (this.verfMsg?.length && this.verfMsg === "Rx, Drug Pick and Pharmacist")
        this.allthreeVerifications = true;
    }
    if(this.selectedRxList?.length){  
      this.selectedRxList.map((item)=>{
        const rxNo = item.PrescNum + "-" + item.Refillnum + (item.Partialfillno ? "-" + item.Partialfillno : "");
        this.verifiedArray.push(rxNo);
      })
          this.verfData = this.verfData + "X";
          this.verfMsg = this.verfMsg + "Rx ";
    }
    if (this.verfData && (this.frmScreen || this.frmResetDrug)) {
      this.confirmMessage = this.verfMsgDisplay();
    }
    this._modalService.open(this.VERFCONFIRMATION, {centered: true, backdrop: false, windowClass: "large--content"});   
  }

  verfMsgDisplay() {
    const mainText = !this.frmResetDrug
    ? (this.rxFG?.value?.pickupRx?.IsPickedUp
        ? 'Prescription has already been picked up. Reversing'
        : 'Reversing this prescription')
    : 'Resetting the drug';

    const boldVerfMsg = this.boldVerfMsg(this.verfMsg);

    const suffix =
      this.allthreeVerifications
        ? `would remove all verified records (${boldVerfMsg})`
        : `would remove ${boldVerfMsg} verified record${this.verfData?.length > 1 ? 's' : ''}`;

    return `${mainText} ${suffix}${this.verfMsg !== "Rx" ? ` and return the quantity to stock` : ''}. Do you wish to proceed?`;
  }

  boldVerfMsg(verfMsg: string): string {
    const itemsToBold = ['Rx', 'Drug Pick', 'Pharmacist'];
    const regex = new RegExp(`\\b(${itemsToBold.join('|')})\\b`, 'g');
    return verfMsg.replace(regex, (match) => `<b>${match}</b>`);
  }


  async removeVerfication(removeVerf) {
    if (removeVerf && !this.selectedRxList?.length) {
      this.rphVerified = false;
      this.rxFG?.controls["IsDeletePillCounterImage"].patchValue(this.removeEyeconImages);
      if (this.frmScreen || this.frmResetDrug) {
        this.rxFG?.controls["isReverifyNeeded"].patchValue(true);
      } else {
        this.rxFG?.controls["isReverifyNeeded"].patchValue(false);
        await this._nrxUtils.updateVerfStatus(this.rxFG?.getRawValue(), this.verfData, this.rxFG || null, true);
        if (this.verfMsg.includes("Drug Pick")) {
            this._auditUtils.getChangedValues(
                null,
                {"DP Verification Status": "Re-Verify"},
                "DP Verification",
                "Rx",
                this.rxFG?.value.PrescReFill.Id
            );
        }
        if (this.verfMsg.includes("Pharmacist")) {
            this._auditUtils.getChangedValues(
                null,
                {"Rph Verification Status": "Re-Verify"},
                "Rph Verification",
                "Rx",
                this.rxFG?.value.PrescReFill.Id
            );
        }
        if (this.verfMsg.includes("Rx")) {
            this._auditUtils.getChangedValues(
                null,
                {"Rx Verification Status": "Re-Verify"},
                "Rx Verification",
                "Rx",
                this.rxFG?.value.PrescReFill.Id
            );
        }
      }
      this.IsPopUpClosed.emit(null);
      this.SelectedYesOrNo.emit(true);
    } 
    else if(removeVerf && this.selectedRxList?.length){
      const payload:any=[]
      this.selectedRxList.map((item:any)=>{
        const data={
          PrescRefillId:item.PrescRefillId,
          PartialfillNum: item.PartialFillNo,
          PrescNum:item.PrescNum,
          Refillnum:item.Refillnum,
          Status: "RV",
          VerifDtTm: moment(Date.now()).format(MsgConfig.DATE_FORMAT),
          PrescId:item.PrescId,
          IsForRxVerification:true,
          SendReadyForPickupAlerts:  this._commonServ.getSetttingValue("MessageSettings", "Send_Ready_For_Pickup_Alerts"),
          SendReadyForPickupAlertsWhen: this._commonServ.getSetttingValue("MessageSettings", "Send_Ready_For_Pickup_Alerts_When")
          
        }
        payload.push(data)
      })
      await this._rphServ.SendBatchRphVerificationDetails(payload).toPromise();
      this.IsPopUpClosed.emit(null);
    }
    else {
      this.rxFG?.controls["IsDeletePillCounterImage"].patchValue(false);
      this.rxFG?.controls["isReverifyNeeded"].patchValue(false);
      this.rphVerified = false;
      this.IsPopUpClosed.emit(null);
      this.SelectedYesOrNo.emit(false);
    }
  }

}
